
angular.module("dyb.programs", [
        'dyb.util.dolRegions',
        'dyb.programs.basic',
        'dyb.programs.model',
        'dyb.programs.grants',
        'dybProgramsInitiatives',
        'dybProgramsAdmin',
        'dybProgramsOverview',
        'dybProgramInfo',
        'dybAnnualSurvey',
        'classy',
    ]);
